import { getFirebaseToken } from '../firebase';  // Importation de la fonction depuis firebase.js

console.log("Backend URL :", process.env.REACT_APP_BACKEND_URL);
const BackEndUrl = process.env.REACT_APP_BACKEND_URL;  // URL du backend depuis les variables d'environnement

// Fonction pour appeler GPT et obtenir une réponse textuelle
export const askGPT = async (message) => {
  console.log("BackEndUrl :", BackEndUrl);  // Vérifiez la sortie pour vous assurer qu'elle n'est pas undefined
  if (!BackEndUrl) {
    console.error("Erreur : REACT_APP_BACKEND_URL est indéfini.");
    return "Erreur de configuration de l'URL API.";
  }

  try {
    const token = await getFirebaseToken();  // Récupérer le token d'ID Firebase
    if (!token) {
      console.error('Token Firebase manquant');
      return "Token Firebase manquant. Vous devez être authentifié.";
    }

    const response = await fetch(`${BackEndUrl}/api/chat`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,  // Ajouter le token dans les en-têtes
      },
      body: JSON.stringify({ message }),
    });

    if (!response.ok) {
      console.error('Erreur avec la requête GPT:', response.status, response.statusText);
      return "Désolé, je n'ai pas pu obtenir de réponse pour le moment.";
    }

    const data = await response.json();
    console.log("Réponse GPT reçue :", data);
    return data.reply;
  } catch (error) {
    console.error("Erreur lors de l'appel à l'API backend GPT:", error);
    return "Désolé, je n'ai pas pu obtenir de réponse pour le moment.";
  }
};

// Fonction pour générer de l'audio à partir d'un texte brut via TTS
export const getAudioFromGPT = async (text) => {
  console.log("BackEndUrl :", BackEndUrl);  // Vérifiez la sortie pour vous assurer qu'elle n'est pas undefined
  if (!BackEndUrl) {
    console.error("Erreur : REACT_APP_BACKEND_URL est indéfini.");
    return null;
  }

  try {
    const token = await getFirebaseToken();  // Récupérer le token d'ID Firebase
    if (!token) {
      console.error('Token Firebase manquant');
      return null;
    }

    const response = await fetch(`${BackEndUrl}/api/tts`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,  // Ajouter le token dans les en-têtes
      },
      body: JSON.stringify({ text }),  // Envoie du texte brut
    });

    if (!response.ok) {
      console.error('Erreur avec la requête audio:', response.status, response.statusText);
      return null;
    }

    const audioBlob = await response.blob();
    const audioUrl = URL.createObjectURL(audioBlob);
    console.log("URL de l'audio généré :", audioUrl);
    return audioUrl;
  } catch (error) {
    console.error("Erreur lors de la génération de l'audio:", error);
    return null;
  }
};
